import React, { useState } from 'react'
import { DialogFormTask } from './DialogFormTask'
import { initialState } from '../../models/tasks'
import { ButtonsCreate } from '../reusableUI/v2UI/ButtonsCreate'
import { Plus } from 'lucide-react'

export const Crear = ({ refreshObj }) => {
    const [open, setOpen] = useState(false)
    // console.log({ refreshObj })

    return (
        <>
            <ButtonsCreate
                icon={<Plus size={16} />}
                name="Nueva Tarea"
                handleClick={() => setOpen(true)}
            />

            {open && (
                <DialogFormTask
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                    handleInitGetTasks={() => { return }}
                    refreshObj={refreshObj || null}
                />
            )}

        </>
    )

}
